import React from 'react';
import ProjectTile from '../components/ProjectTile';
import './ProjectsPage.css';

const projects = [
    {
        id: 1,
        title: "Fachwerk: Sanierung, Neubau und Anbau",
        subtitle: "“Der fahrende Fachwerker”: Sommerbaustellen Europaweit mit Materialbeschaffung und Abbund vor Ort",
        images: [
            "/images/Fachwerk1.jpg",
            "/images/Fachwerk2.jpg",
        ],
    },
    {
        id: 2,
        title: "Alles am Dach",
        subtitle: "Dachstühle und Dachsanierungen, Gauben und Dachfenster",
        images: [
            "/images/Schindeln.JPG",
        ],
    },
    {
        id: 3,
        title: "Baumhäuser und Tiny Häuser",
        subtitle: "Vorfertigung in Leipzig, Montage bzw. Lieferung Europaweit",
        images: [
            "/images/Baumhaus.JPG",
            "/images/Tiny.JPG",
        ],
    },
    {
        id: 4,
        title: "Jegliche Zimmerarbeiten",
        subtitle: "",
        images: [
            "/images/Eichenboden.jpg"
        ],
    },
    {
        id: 5,
        title: "Entwurf und Planung",
        subtitle: "Entwurf und Planung für Holzbau Vorhaben mit SEMA Software",
        images: [
            "/images/Fachwerk.jpg",
        ],
    },
];

function ProjectsPage() {
    return (
        <div>
            <h1>Projekte</h1>
            <p>Je nach Größe, realisiere ich Projekte in Zusammenarbeit mit meinen Kollegen vom <a href="https://holzbau-netzwerk-leipzig.de">HolzbauNetzwerkLeipzig</a>.</p>
            <div className="projects-container">
                <div className="projects-grid">
                    {projects.map(project => (
                        <ProjectTile key={project.id} project={project} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ProjectsPage;